import { Form, InputNumber } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Frequency } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function FrequencyEditPage(props: { frequency?: Frequency; onSaved: (frequency?: Frequency) => void; onCancel: () => void }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const formValues: any = {
    ...props.frequency,
  };

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.frequency) {
      apiClient
        .post('frequencies', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`frequencies/${props.frequency?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form form={form} layout="vertical" name="basic" onFinish={onFinish} initialValues={formValues}>
      <Form.Item
        label="En düşük"
        name="lowest"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            message: 'En düşük değer en yüksek değerden küçük olmalıdır',
            validator: (_, value) => {
              const highestValue = form.getFieldValue('highest');
              if (!highestValue) {
                return Promise.resolve();
              }
              if (value <= parseFloat(highestValue)) {
                return Promise.resolve();
              } else {
                return Promise.reject();
              }
            },
          },
        ]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item
        label="En yüksek"
        name="highest"
        rules={[
          {
            message: 'En yüksek değer en küçük değerden büyük olmalıdır',
            validator: (_, value) => {
              const lowestValue = form.getFieldValue('lowest');
              if (!value) {
                return Promise.resolve();
              }
              if (parseFloat(lowestValue) <= value) {
                return Promise.resolve('lowest');
              } else {
                return Promise.reject();
              }
            },
          },
        ]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item label="Öncelik puanı" name="priorityScore" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
